import { Box, Button, Stack } from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  Color,
  EduPostTypes,
  FontStyle,
  JobDisplays,
  Slug,
  SurveyButtonStyle,
} from "../../constants";
import { loadedYtScript } from "../../utils/actionUtils";
import JobResourceVid from "../JobPanels/JobResourceVid";
import ShortTextPanel from "./ShortTextPanel";

const ShortPostForwarder = ({ post, idx, setIdx, logEduClick = () => {} }) => {
  const dispatch = useDispatch();
  const ytScriptLoaded = useSelector((state) => state.vid.ytScriptLoaded);
  const { type, data, firstVideo } = post;
  if (type === EduPostTypes.text) {
    return (
      <ShortTextPanel
        data={data}
        idx={idx}
        setIdx={setIdx}
        logClick={logEduClick}
      />
    );
  }
  if (type === EduPostTypes.video) {
    const { src } = data;
    return (
      <JobResourceVid
        src={src}
        setMainSrc={() => setIdx(idx)}
        active
        setYtScriptLoaded={firstVideo ? loadedYtScript(dispatch) : null}
        ytScriptLoaded={ytScriptLoaded}
        logClick={logEduClick}
        // vidHeightOverWidth={1}
      />
    );
  }
};

export default ShortPostForwarder;
